import 'whatwg-fetch'
import ForbiddenError from './errors/ForbiddenError'
import NotFoundError from './errors/NotFoundError'
import NonAvailableError from './errors/NonAvailableError'


const buildForbiddenError = async (response) => {
  try {
    const body = await response.json()
    const { error = {} } = body
    const { message, name } = error
    return new ForbiddenError(message, name)
  } catch (err) {
    throw err
  }
}

const buildNotFoundError = async (response) => {
  try {
    const body = await response.json()
    const { error = {} } = body
    const { message } = error
    return new NotFoundError(message)
  } catch (err) {
    throw err
  }
}

const buildNonAvailableError = async (response) => {
  try {
    const body = await response.json()
    const { error = {} } = body
    const { message } = error
    return new NonAvailableError(message)
  } catch (err) {
    throw err
  }
}

const parseResponse = (response) => {
  const contentType = response.headers.get('content-type')
  return contentType && contentType.includes('application/json')
    ? response.json()
    : response.text()
}

const verifyResponse = async (response) => {
  if (response.ok) {
    return response
  }

  if (response.status === 403) {
    throw await buildForbiddenError(response)
  }

  if (response.status === 404) {
    throw await buildNotFoundError(response)
  }

  if (response.status === 500 || response.status === 503) {
    throw await buildNonAvailableError(response)
  }

  throw new Error('Bad response from server')
}

async function request(url) {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
  const response = await fetch(url, options)
  const verifiedResponse = await verifyResponse(response)
  return parseResponse(verifiedResponse)
}

export default request
